
export const ADDTO_WISHLIST_REQUEST = "ADDTO_WISHLIST_REQUEST";
export const ADDTO_WISHLIST_SUCCESS = "ADDTO_WISHLIST_SUCCESS";
export const ADDTO_WISHLIST_FAILURE = "ADDTO_WISHLIST_FAILURE";
